import { supabase } from '../lib/supabaseClient.js';
import { TABLES, ROLES } from '../lib/constants.js';

async function functionError(error) {
  let message = error?.message || 'تعذر إكمال العملية';
  const response = error?.context;
  if (response && typeof response.clone === 'function') {
    try {
      const body = await response.clone().json();
      if (typeof body?.error === 'string' && body.error.trim()) message = body.error;
    } catch {
      // The response may not contain JSON.
    }
  }
  return new Error(message);
}

export async function listStaff() {
  const { data, error } = await supabase.from(TABLES.PROFILES)
    .select('id,full_name,email,phone,specialty,role,active')
    .in('role', [ROLES.OWNER, ROLES.ADMIN, ROLES.FOREMAN, ROLES.TECHNICIAN])
    .order('full_name');
  if (error) throw error;
  return (data || []).sort((a, b) => {
    const roleOrder = {
      [ROLES.OWNER]: 0,
      [ROLES.ADMIN]: 1,
      [ROLES.FOREMAN]: 2,
      [ROLES.TECHNICIAN]: 3
    };
    const byRole = (roleOrder[a.role] ?? 99) - (roleOrder[b.role] ?? 99);
    return byRole || String(a.full_name || '').localeCompare(String(b.full_name || ''), 'ar');
  });
}

export async function updateStaffProfile(id, patch) {
  const allowedFields = ['full_name', 'phone', 'specialty'];
  const fields = Object.keys(patch);
  if (fields.length === 0 || fields.some(field => !allowedFields.includes(field))) {
    throw new Error('يمكن تعديل الاسم ورقم الجوال والتخصص فقط.');
  }
  const { data, error } = await supabase.from(TABLES.PROFILES).update(patch).eq('id', id).select().single();
  if (error) throw error;
  return data;
}

export async function createStaffAccount({ email, tempPassword, fullName, role, specialty, phone }) {
  const { data, error } = await supabase.functions.invoke('create-staff-user', {
    body: { action: 'create', email, tempPassword, fullName, role, specialty, phone }
  });
  if (error) throw await functionError(error);
  if (data?.error) throw new Error(data.error);
  return data;
}

export async function manageStaffAccount({ profileId, role, active }) {
  const { data, error } = await supabase.functions.invoke('create-staff-user', {
    body: { action: 'update', profileId, role, active }
  });
  if (error) throw await functionError(error);
  if (data?.error) throw new Error(data.error);
  return data;
}

export async function listInspectionTenants() {
  const { data, error } = await supabase.from(TABLES.PROFILES)
    .select('id,full_name,phone,active').eq('role', ROLES.TENANT).order('full_name');
  if (error) throw error;
  return data || [];
}
